import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return { el: to.hash }
        }
        return { top: 0 }
    },
    routes: [
        {
            path: '/:lang(en)?',
            name: 'Main',
            component: () => import('@/pages/Main.vue')
        },
        {
            path: '/:lang(en)?/projects',
            name: 'Projects',
            component: () => import('@/pages/Projects.vue')
        },
        {
            path: '/:lang(en)?/projects/:alias',
            name: 'Project',
            component: () => import('@/pages/Project.vue')
        },
        {
            path: '/:lang(en)?/blog',
            name: 'Blog',
            component: () => import('@/pages/Blog.vue')
        },
        {
            path: '/:lang(en)?/blog/:alias',
            name: 'BlogPost',
            component: () => import('@/pages/BlogPost.vue')
        },
        {
            path: '/:lang(en)?/studio',
            name: 'Studio',
            component: () => import('@/pages/Studio.vue')
        },
        {
            path: '/:lang(en)?/contacts',
            name: 'Contacts',
            component: () => import('@/pages/Contacts.vue')
        },
        {
            path: '/politika-konfidencialnosti',
            name: 'PrivacyPolicy',
            component: () => import('@/pages/PrivacyPolicy.vue')
        },
        {
            path: '/en/politika-konfidencialnosti',
            name: 'PrivacyPolicyEn',
            component: () => import('@/pages/PrivacyPolicy.vue')
        }
    ]
})

export default router
